import { render, staticRenderFns } from "./Reviews.vue?vue&type=template&id=1a695566&scoped=true"
import script from "./Reviews.vue?vue&type=script&lang=ts"
export * from "./Reviews.vue?vue&type=script&lang=ts"
import style0 from "./Reviews.vue?vue&type=style&index=0&id=1a695566&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a695566",
  null
  
)

export default component.exports